import { render, staticRenderFns } from "./view-game.vue?vue&type=template&id=9ee7b636&scoped=true&"
import script from "./view-game.vue?vue&type=script&lang=js&"
export * from "./view-game.vue?vue&type=script&lang=js&"
import style0 from "./view-game.vue?vue&type=style&index=0&id=9ee7b636&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ee7b636",
  null
  
)

export default component.exports